import React from 'react';
import { useTranslation } from 'react-i18next';

import './styles.scss';

const PageTitle = ({ titleKey, subtitleKey, secondary }) => {
  const { t } = useTranslation();

  return (
    <>
      {secondary ? <h3 className="page-sub-title">{t(titleKey)}</h3> : <h2 className="page-title">{t(titleKey)}</h2>}
      {subtitleKey && <p className="page-paragraph">{t(subtitleKey)}</p>}
    </>
  );
};

export default PageTitle;
